// START_MODULE navigation_labels
// START_CONTRACT
// PURPOSE: Map each maintained landing section to its Russian navigation label.
// OPERATIONAL_CONTEXT: Called while rendering the fixed landing-page navigation.
// CONTRACT: Return a concise label for every navigable section; MAIN has no menu entry.
// KEYWORDS: navigation, labels, russian
// COMPLEXITY: 2
// END_CONTRACT
import { Section } from 'routes/section';

export const getLinkTitle = (section: Section) => {
  switch (section) {
    case Section.DESCRIPTION:
      return 'Описание';
    case Section.GALLERY:
      return 'Галерея';
    case Section.STATISTICS:
      return 'Цифры';
    case Section.NEWS:
      return 'Новости';
    case Section.CONTACTS:
      return 'Мы в соцсетях';
    case Section.ANNOUNCEMENTS:
      return 'Анонсы';
    default:
      return 'Неизвестно';
  }
};
// END_MODULE navigation_labels
